import { createFileRoute } from "@tanstack/react-router";
import OwnerSeoPage from "@/pages/OwnerSeoPage";

export const Route = createFileRoute("/_owner/owner/seo")({
  component: OwnerSeoPage,
});
